// ============================================================================
// METRIC VALUE COMPONENT
//
// Displays a percentage metric with:
// - Main value (e.g. "45%")
// - Numerator / denominator below (e.g. "17 / 38")
// - "Low sample" badge when denominator < 20
// - "—" with "0 runs" when denominator === 0
//
// Usage:
//   <MetricValue numerator={17} denominator={38} />
//   <MetricValue numerator={0} denominator={0} />  // shows "—" and "0 runs"
// ============================================================================

import React from 'react';

const MetricValue = ({
  numerator = 0,
  denominator = 0,
  suffix = '%',
  lowSampleThreshold = 20,
  emptyLabel = '0 runs',
  precision = 0,
  valueClassName = 'text-2xl md:text-3xl font-semibold text-white',
}) => {
  // Empty state
  if (denominator === 0) {
    return (
      <div>
        <p className={`${valueClassName} !text-slate-500`}>&mdash;</p>
        <p className="text-xs text-slate-600 mt-0.5">{emptyLabel}</p>
      </div>
    );
  }

  const pct = (numerator / denominator) * 100;
  const displayValue = `${pct.toFixed(precision)}${suffix}`;
  const isLowSample = denominator < lowSampleThreshold;

  return (
    <div>
      <p className={valueClassName}>{displayValue}</p>
      <div className="flex items-center gap-2 mt-0.5">
        <span className="text-xs text-slate-500 font-mono">{numerator} / {denominator}</span>
        {isLowSample && (
          <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-500/10 text-amber-400 border border-amber-500/20">
            Low sample
          </span>
        )}
      </div>
    </div>
  );
};

export default MetricValue;
